import { ReactComponent as ClipIcon } from '@/assets/icons/clip-icon.svg'
import { AddAttachmentButton } from '.'

// eslint-disable-next-line
export function AndroidToolbar (props) {
  return (<>
    <div className='action-bar-section'>
      <div className="left-content">
        <div className="action-group">
          
        </div>
      </div>
      <div className='right-content'>
        <div className="action clip clip-right">
          <AddAttachmentButton>
            <span>Add attachments</span><ClipIcon/>
          </AddAttachmentButton>
        </div>
      </div>
    </div>
  </>
  )
}
